import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavBar.css";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile drawer on route transition
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "About Doctor", path: "/aboutus" },
    { label: "Surgeries & Care", path: "/services" },
    { label: "Articles", path: "/blogs" },
    { label: "Gallery", path: "/gallery" },
    { label: "Patient Resources", path: "/usefullinks" },
    { label: "Contact", path: "/contact" },
  ];

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="site-header-sticky">
      {/* Clinic Top Bar */}
      <div className="clinic-topbar d-none d-lg-block">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="topbar-left d-flex gap-4">
            <span className="topbar-item">
              <i className="fa-solid fa-location-dot me-2 text-teal"></i>
              Medicover Out Patient Center, HITEC City, Hyderabad
            </span>
            <span className="topbar-item">
              <i className="fa-regular fa-clock me-2 text-teal"></i>
              Mon - Sat: 10:00 AM - 04:00 PM
            </span>
          </div>
          <div className="topbar-right d-flex gap-4 align-items-center">
            <a href="tel:+918341555765" className="topbar-link">
              <i className="fa-solid fa-phone me-2 text-teal"></i>
              +91 8341555765
            </a>
            <a href="mailto:contact@arthroscopydoc.com" className="topbar-link">
              <i className="fa-solid fa-envelope me-2 text-teal"></i>
              contact@arthroscopydoc.com
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className={`navbar navbar-expand-lg ${isScrolled ? "navbar-scrolled" : ""}`}>
        <div className="container">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-3">
            <img
              src="/images/logo_new.png"
              alt="Dr. Sunil Apsingi Logo"
              className="navbar-brand-logo"
            />
            <div className="brand-text-block">
              <span className="brand-name">Dr. Sunil Apsingi</span>
              <span className="brand-title">Chief Arthroscopy & </span>
              <span className="brand-title">Joint Replacement Surgeon</span>
            </div>
          </Link>

          <button
            className={`navbar-toggler ${isMenuOpen ? "active" : ""}`}
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-controls="mainNavbar"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="mainNavbar">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              {navLinks.map((item) => (
                <li key={item.path} className="nav-item">
                  <Link
                    to={item.path}
                    className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li className="nav-item ms-lg-2 mt-3 mt-lg-0">
                <Link to="/bookappointment" className="btn-medical-primary">
                  <i className="fa-regular fa-calendar-check"></i>
                  Book Consultation
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default NavBar;
